export enum GroupSessionSocketEventName {
  SessionRecapReminder = 'sessionRecapReminder',
}
